/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { Tile } from '@carbon/react';

import { TileRow, TileValue, TileValueGreen, StyledTile } from './TestSummaryTiles.styled';

/**
 * Displays test summary statistics in a row of tiles
 *
 * @param {Object} props
 * @param {Object} props.testSummaryResults - Test summary data
 * @param {string|number} props.testSummaryResults.averageConfidence - Average confidence percentage
 * @param {number} props.testSummaryResults.averageNumberOfFieldsExtracted - Average number of fields extracted
 * @param {number} props.testSummaryResults.totalNumberOfFieldsExtracted - Total number of fields
 * @param {number} props.testSummaryResults.averageNumberOfTablesExtracted - Average number of tables extracted
 * @param {number} props.testSummaryResults.totalNumberOfTablesExtracted - Total number of tables
 * @returns {JSX.Element}
 */
export function TestSummaryTiles({ testSummaryResults }) {
  const averageNumberOfFieldsExtracted = `${testSummaryResults.averageNumberOfFieldsExtracted} / ${testSummaryResults.totalNumberOfFieldsExtracted}`;
  const averageNumberOfTablesExtracted = `${testSummaryResults.averageNumberOfTablesExtracted} / ${testSummaryResults.totalNumberOfTablesExtracted}`;

  return (
    <TileRow>
      <StyledTile as={Tile}>
        <TileValueGreen>{`${testSummaryResults.averageConfidence}%`}</TileValueGreen>
        <div>Average Confidence</div>
      </StyledTile>
      <StyledTile as={Tile}>
        <TileValue>{averageNumberOfFieldsExtracted}</TileValue>
        <div>Average Fields Extracted</div>
      </StyledTile>
      <StyledTile as={Tile}>
        <TileValue>{averageNumberOfTablesExtracted}</TileValue>
        <div>Average Tables Extracted</div>
      </StyledTile>
    </TileRow>
  );
}
